import { render, staticRenderFns } from "./TransparentMeshMaterial.vue?vue&type=template&id=7deeb64e&"
import script from "./TransparentMeshMaterial.vue?vue&type=script&lang=js&"
export * from "./TransparentMeshMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports